import {
  Button,
  Divider,
  Grid2 as Grid,
  List,
  ListItem,
  Modal,
  Tooltip,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { Header, Section, SectionTitle } from "./styles/styles";
import { SeeMore } from "components/Text/SeeMore";
import { useState } from "react";
import { TextFieldWrapper } from "components/Wrappers/FormComponentsWrappers/TextFieldWrapper";
import { inputOutputUpdateApi } from "API/apis/product/inputOutputUpdate";
import { STATUS_CODES } from "constants/responses/statusCodes";
import { useGlobalContext } from "context/GlobalContext";
import { message } from "constants/responses/message";
import { useProductContext } from "../context";
import { useSelector } from "react-redux";
import { docCodeGeneratorGlobal } from "utils/functions/docCodeGenerator";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export const InputOutputViewerComponent = ({
  partLotId,
  title,
  inputData,
  outputData,
  availableInputItems,
  availableOutputItems,
  reFetchInputOutput,
}) => {
  const { bdc } = useProductContext();
  const currentUserId = useSelector((state) => state.user.state.userId);

  const { setError, setSuccess, setIsInitializing } = useGlobalContext();
  const [editForm, setEditForm] = useState({
    type: "",
    timelineItem: "",
    detail: "",
    field: "",
    partLotId: 0,
  });

  const [editOpen, setEditOpen] = useState(false);
  const handleDoubleClickForEditDetail = ({
    type,
    timelineItem,
    detail,
    field,
    partLotId,
  }) => {
    setEditForm({ type, timelineItem, detail, field, partLotId });
    setEditOpen(true);
  };
  const handleCloseEditPopup = () => {
    setEditOpen(false);
  };
  const submitChange = async () => {
    setIsInitializing(true);
    try {
      const { data, status } = await inputOutputUpdateApi({
        ...editForm,
      });
      if (status !== STATUS_CODES.SUCCESS) {
        throw new Error(data.message);
      }
      setSuccess(message.success.updatedSuccessfully);
      reFetchInputOutput(partLotId);
    } catch (error) {
      setError(error.message);
    } finally {
      setIsInitializing(false);
      setEditOpen(false);
    }
    setIsInitializing(true);
  };
  return (
    <>
      <Modal
        open={editOpen}
        onClose={handleCloseEditPopup}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Edit Detail
          </Typography>
          <TextFieldWrapper
            id="details"
            name="details"
            label={editForm.field}
            variant="outlined"
            value={editForm.detail}
            fullWidth
            inputProps={{ min: 1 }}
            required
            autoFocus
            onChange={(e) =>
              setEditForm({ ...editForm, detail: e.target.value })
            }
          />
          <Button variant="contained" fullWidth onClick={() => submitChange()}>
            Submit
          </Button>
        </Box>
      </Modal>

      <Box sx={{ overflow: "hidden", borderRadius: 1, boxShadow: 1 }}>
        <Grid container xs={12} md={6}>
          <Header>
            <Typography variant="h6">{title}</Typography>
          </Header>
          <Box>
            {title !== "Handover" && (
              <Section>
                <SectionTitle variant="subtitle1">Input</SectionTitle>
                <List dense>
                  {availableInputItems?.map((item, index) => (
                    <ListItem key={`input-${index}`} disablePadding>
                      <Box color={inputData?.[item] ? "" : "red"}>
                        <Typography sx={{ textDecoration: "underline" }}>
                          {item}
                        </Typography>
                        <Tooltip title="Double click to edit">
                          <Box
                            variant="text"
                            sx={{
                              cursor: "pointer",
                              fontStyle: "italic",
                              fontSize: 10,
                            }}
                            onDoubleClick={() =>
                              bdc === currentUserId &&
                              handleDoubleClickForEditDetail({
                                type: "INPUT",
                                timelineItem: title,
                                detail: inputData?.[item] || "",
                                field: item,
                                partLotId,
                              })
                            }
                          >
                            {inputData?.[item] ? (
                              <SeeMore text={inputData?.[item]} />
                            ) : (
                              "No data"
                            )}
                          </Box>
                        </Tooltip>
                      </Box>
                    </ListItem>
                  ))}
                </List>
              </Section>
            )}
            <Divider />

            <Section>
              <SectionTitle variant="subtitle1">Output</SectionTitle>
              <List dense>
                {availableOutputItems?.map((item, index) => (
                  <ListItem key={`output-${index}`} disablePadding>
                    <Box
                      color={
                        outputData?.[item] || item === "Handover checklist"
                          ? ""
                          : "red"
                      }
                    >
                      <Typography sx={{ textDecoration: "underline" }}>
                        {item}
                      </Typography>
                      {item === "Handover checklist" &&
                        title === "Handover" && <></>}
                      {item === "Handover code" && title === "Handover" && (
                        <SeeMore
                          text={
                            outputData?.[item]
                              ? docCodeGeneratorGlobal({
                                  id: outputData?.[item],
                                  docType: "HANDOVER_CHECKLIST",
                                })
                              : "No data"
                          }
                        />
                      )}
                      {title !== "Handover" && (
                        <Tooltip title="Double click to edit">
                          <Box
                            variant="text"
                            sx={{
                              cursor: "pointer",
                              fontStyle: "italic",
                              fontSize: 10,
                            }}
                            onDoubleClick={() =>
                              bdc === currentUserId &&
                              handleDoubleClickForEditDetail({
                                type: "OUTPUT",
                                timelineItem: title,
                                detail: outputData?.[item] || "",
                                field: item,
                                partLotId,
                              })
                            }
                          >
                            {outputData?.[item] ? (
                              <SeeMore text={outputData?.[item]} />
                            ) : (
                              "No data"
                            )}
                          </Box>
                        </Tooltip>
                      )}
                    </Box>
                  </ListItem>
                ))}
              </List>
            </Section>
          </Box>
        </Grid>
      </Box>
    </>
  );
};
